var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49988 5.00002H4.16654M4.16654 5.00002H17.4999M4.16654 5.00002V16.6667C4.16654 17.1087 4.34214 17.5326 4.6547 17.8452C4.96726 18.1578 5.39118 18.3334 5.83321 18.3334H14.1665C14.6086 18.3334 15.0325 18.1578 15.3451 17.8452C15.6576 17.5326 15.8332 17.1087 15.8332 16.6667V5.00002H4.16654ZM6.66654 5.00002V3.33335C6.66654 2.89133 6.84214 2.4674 7.1547 2.15484C7.46726 1.84228 7.89118 1.66669 8.33321 1.66669H11.6665C12.1086 1.66669 12.5325 1.84228 12.8451 2.15484C13.1576 2.4674 13.3332 2.89133 13.3332 3.33335V5.00002M8.33321 9.16669V14.1667M11.6665 9.16669V14.1667",
    stroke: "#F04438",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.4ac26541dea428e15659f801227fa367.svg";
export { ForwardRef as ReactComponent };